/******************************************
*  Author : Riccardo Di Dato   
*  Created On : Wed Sep 28 2022
*  File : PersonalDataCompletionEvaluationConverter.ts
*******************************************/

import { isSubmitPersonalDataCompletion, SubmitPersonalDataCompletion } from "../../EvaluatedAction.js";
import { CTA_NAME, CTA_OUTCOME, CTAStatsDetails } from "@api-commons/stats/CTATypes.js";
import { EvaluationConverter } from "../EvaluationConverter.js";
import { AuthProviderIdentifier } from "@api-commons/login/AuthProviderIdentifier.js";

export class PersonalDataCompletionEvaluationConverter implements EvaluationConverter {
    public check = isSubmitPersonalDataCompletion;
    
    public convert(action: SubmitPersonalDataCompletion): CTAStatsDetails {
        return {
            outcome: CTA_OUTCOME.SHOWN,
            source_element: "evaluation",
            provider: action.data.hintProvider == AuthProviderIdentifier.APPLE?AuthProviderIdentifier.APPLE:AuthProviderIdentifier.GOOGLE,
            action: CTA_NAME.PERSONAL_DATA
        };
    }
}